export default __webpack_public_path__ + "static/media/hu.cc53e07f.svg";